__turbopack_context__.v({
  "financialsSectionWrapper": "FinancialsSection-module-scss-module__lmmnhq__financialsSectionWrapper",
});
